import { getAPIBaseURL } from './helpers'
import { getData, postData } from './request'

const base = () => `${getAPIBaseURL()}/v1`

export const initOrder = async (payload) => {
  const url = `${base()}/orders/initialize`
  const token = localStorage.getItem('token')
  
  // Convert payload to URL-encoded format
  const formData = new URLSearchParams()
  if (payload.eventId) formData.append('eventId', payload.eventId)
  if (payload.currency) formData.append('currency', payload.currency)
  if (payload.fees !== undefined) formData.append('fees', payload.fees.toString())
  
  // Handle items array - convert to form-encoded format
  if (payload.items && Array.isArray(payload.items)) {
    payload.items.forEach((item, index) => {
      if (item.ticketTypeId) formData.append(`items[${index}][ticketTypeId]`, item.ticketTypeId)
      if (item.quantity !== undefined) formData.append(`items[${index}][quantity]`, item.quantity.toString())
    })
  }
  
  const headers = { 
    'Content-Type': 'application/x-www-form-urlencoded',
    ...(token ? { 'token': token } : {})
  }
  const res = await postData(url, headers, formData.toString())
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data?.data || res.result.data }
  }
  // Extract error message from response
  const errorData = res.result?.data
  const errorMessage = errorData?.data || errorData?.message || errorData || 'Failed to initialize order'
  return { 
    status: res.result?.status || 500, 
    error: errorMessage 
  }
}

export const listOrders = async () => {
  const url = `${base()}/orders`
  const res = await getData(url, {}, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data }
}

export const listCenterOrders = async () => {
  const url = `${base()}/center/orders`
  const token = localStorage.getItem('token')
  const headers = token ? { 'token': token } : {}
  const res = await getData(url, headers, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data }
}

export const listAdminOrders = async () => {
  const url = `${base()}/admin/orders`
  const token = localStorage.getItem('token')
  const headers = token ? { 'token': token } : {}
  const res = await getData(url, headers, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data }
}

export const getAdminOrderById = async (orderId) => {
  const url = `${base()}/admin/orders/${orderId}`
  const token = localStorage.getItem('token')
  const headers = token ? { 'token': token } : {}
  const res = await getData(url, headers, {})
  if (res.error === '') {
    return { status: res.result.status, data: res.result.data.data || res.result.data }
  }
  return { status: res.result?.status || 500, error: res.result?.data }
}

